import React from 'react'
import { makeStyles, LinearProgress } from '@material-ui/core'

const useStyles = makeStyles(theme => {
  return {
    categoryItem: {
      marginBottom: '18px',
    },
    categoryItemHeader: {
      display: 'flex',
      marginBottom: '14px',
    },
    categoryName: {
      fontSize: '12px',
      fontWeight: 600,
      lineHeight: '18px',
      letterSpacing: '0em',
      fontStyle: 'normal',
      styleName: 'note bold',
    },
    categoryCount: {
      paddingLeft: '4px',
      color: '#32AE6C',
      fontSize: '12px',
      fontWeight: 600,
      lineHeight: '18px',
    },
    categoryPercent: {
      color: '#474747',
      flex: 1,
      textAlign: 'right',
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '18px',
    },
    categoryProgressLine: {
      height: '4px',
      backgroundColor: '#E8EBEF',
      borderRadius: 2,
    },
    backgroundSevere: {
      backgroundColor: '#790202',
    },
    backgroundWatch: {
      backgroundColor: '#D10000',
    },
    backgroundRR: {
      backgroundColor: '#FF5C5C',
    },
    backgroundNeutral: {
      backgroundColor: '#758396',
    },
  }
})

interface SummaryStatsBoxProps {
  d: any
  total: any
}

const SummaryStatsBox = ({ d, total }: SummaryStatsBoxProps) => {
  const classes = useStyles()

  return (
    <div className={classes.categoryItem}>
      <div className={classes.categoryItemHeader}>
        <div className={classes.categoryName}>{d.title}</div>
        <div className={classes.categoryCount}>{d.count}</div>
        <div className={classes.categoryPercent}>{`${(
          (d.count / total) *
          100
        ).toFixed(0)}%`}</div>
      </div>
      <LinearProgress
        classes={{
          root: classes.categoryProgressLine,
          bar:
            d.title === 'Elevated 3'
              ? classes.backgroundSevere
              : d.title === 'Elevated 2'
              ? classes.backgroundRR
              : d.title === 'Elevated 1'
              ? classes.backgroundWatch
              : classes.backgroundNeutral,
        }}
        variant="determinate"
        value={(d.count / total) * 100}
      />
    </div>
  )
}

export default SummaryStatsBox
